/* eslint-disable @typescript-eslint/no-unused-vars */
import _ from 'lodash'
import React, { memo } from 'react'
import { useTheme } from 'styled-components'

import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { IBarrierTypeIcon, IMethod } from 'plugin-codaf-risk-ext-bowtie/types'
import { Icon, getZoomLevel } from 'plugin-codaf-risk-ext-bowtie/utils'
import {
    barrierWidth,
    barrierHeight,
    // escalationHeight,
    // barrierEditorGap,
    unfocusOpacity
} from 'plugin-codaf-risk-ext-bowtie/utils/constants'

import { IBarrierTypes, IEditorBarrier, IEditorEscalation } from '../../../../BarrierEditor'
import { EscalationFactor } from './components'
import { BarrierContainer, TextContainer } from './styles'

interface IProps {
    x: number
    y: number
    barrierData: IEditorBarrier
    zoomScale: number
    primaryBarrier?: boolean
    handleEditBarrier?: (k: IEditorBarrier | IEditorEscalation, type: IBarrierTypes) => void
    handleDeleteBarrierClick?: () => void
    handleBarrierChange: () => void
    beforeBrothersEscalationsLength: number
    editingItem: IEditorBarrier | IEditorEscalation
    handleGetRecursiveSearch: (barrierRef: IEditorBarrier) => IEditorBarrier[]
    handleGetRecursiveSearchFromEscalation: (escalationRef: IEditorEscalation) => IEditorEscalation[]
    selectedMethod: IMethod
    barrierTypeIconMap: Map<number, IBarrierTypeIcon>
}

const BarrierToEdit: React.FC<IProps> = ({
    barrierData,
    x,
    y,
    zoomScale,
    primaryBarrier,
    handleEditBarrier,
    beforeBrothersEscalationsLength,
    handleDeleteBarrierClick: handleDeleteClick,
    handleBarrierChange,
    editingItem,
    handleGetRecursiveSearch,
    handleGetRecursiveSearchFromEscalation,
    selectedMethod,
    barrierTypeIconMap
}) => {
    const theme = useTheme()
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    // const handleAddEscalationFactor = (): void => {
    //     const recursiveArrayOfBarrier = handleGetRecursiveSearch(barrierData)

    //     const escalationToAdd: IEditorEscalation = {
    //         id: null,
    //         uid: _.uniqueId(),
    //         name: null,
    //         barriers: [],
    //         getFather: barrierData
    //     }

    //     if (barrierData.root) {
    //         if (!barrierData.escalations.length) {
    //             barrierData.escalations = [escalationToAdd]
    //         } else {
    //             barrierData.escalations = [...barrierData.escalations, escalationToAdd]
    //         }
    //     } else {
    //         if (recursiveArrayOfBarrier[0].id) {
    //             recursiveArrayOfBarrier.forEach(bar => {
    //                 bar.initialPFD = undefined
    //                 if (!bar.escalations.length) {
    //                     bar.escalations = [escalationToAdd]
    //                 } else {
    //                     bar.escalations = [...bar.escalations, escalationToAdd]
    //                 }
    //             })
    //         } else {
    //             recursiveArrayOfBarrier[0].initialPFD = undefined
    //             if (!recursiveArrayOfBarrier[0].escalations.length) {
    //                 recursiveArrayOfBarrier[0].escalations = [escalationToAdd]
    //             } else {
    //                 recursiveArrayOfBarrier[0].escalations = [
    //                     ...recursiveArrayOfBarrier[0].escalations,
    //                     escalationToAdd
    //                 ]
    //             }
    //         }
    //     }

    //     handleBarrierChange()
    //     handleEditBarrier(escalationToAdd, 'ESCALATIONFACTOR')
    // } // função 1

    const handleBeforeExpanded = (esc: IEditorEscalation): number => {
        let number = 1

        if (esc.barriers) {
            for (const barrier of esc.barriers) {
                if (barrier.escalations) {
                    for (const escalation of barrier.escalations as IEditorEscalation[]) {
                        number += handleBeforeExpanded(escalation)
                    }
                }
            }
        }

        return number
    }

    const onDeleteEscalationRequest = (item: IEditorEscalation): void => {
        if (barrierData.root) {
            const newArray = (barrierData.escalations as IEditorEscalation[]).filter(e => {
                if (e.id) {
                    return e.id !== item.id
                } else {
                    return e.uid !== item.uid
                }
            })
            barrierData.escalations = [...newArray]
        } else {
            const recursiveArrayOfBarrier = handleGetRecursiveSearch(barrierData)
            recursiveArrayOfBarrier.forEach(bar => {
                const newArray = (bar.escalations as IEditorEscalation[]).filter(e => {
                    if (e.id) {
                        return e.id !== item.id
                    } else {
                        return e.uid !== item.uid
                    }
                })
                bar.escalations = [...newArray]
            })
        }

        handleBarrierChange()
    }

    // const escalationAddButton = (): JSX.Element => {
    //     const lastIndex = barrierData.escalations?.length - 1 || 0

    //     const lastIndexX = barrierData.escalations[lastIndex]?.barriers?.length || 0
    //     const lineX = x - barrierWidth * 2 - lastIndexX * (barrierWidth + barrierEditorGap) + 50

    //     const expanded = []

    //     for (let i = 0; i < lastIndex; i++) {
    //         expanded.push(handleBeforeExpanded((barrierData.escalations as IEditorEscalation[])[i]))
    //     }

    //     const lineY =
    //         y +
    //         barrierHeight * 2 +
    //         (expanded.reduce((a, b) => a + b, 0) + (beforeBrothersEscalationsLength || 0)) * (barrierHeight * 3)

    //     return (
    //         <AddButton
    //             escalationLength={barrierData.escalations.length}
    //             x={lineX}
    //             y={lineY + escalationHeight}
    //             onAddRequest={handleAddEscalationFactor}
    //             customText="Escalation Factor"
    //             type="ESCALATIONFACTOR"
    //             opacity={editingItem ? unfocusOpacity : 1}
    //         />
    //     )
    // }

    return (
        <>
            {barrierData?.escalations?.length ? (
                <>
                    {barrierData.escalations?.map(
                        (escalation: IEditorEscalation, idx, escalations: IEditorEscalation[]) => {
                            const expanded = []

                            for (let i = 0; i < idx; i++) {
                                expanded.push(handleBeforeExpanded(escalations[i]))
                            }

                            const lineY =
                                y +
                                barrierHeight * 2 +
                                (expanded.reduce((a, b) => a + b, 0) + (beforeBrothersEscalationsLength || 0)) *
                                    (barrierHeight * 3)

                            return (
                                <EscalationFactor
                                    key={idx}
                                    escalationData={escalation}
                                    yFather={y}
                                    x={x}
                                    y={lineY}
                                    handleEditBarrier={handleEditBarrier}
                                    handleDeleteEscalationClick={() => onDeleteEscalationRequest(escalation)}
                                    handleBarrierChange={handleBarrierChange}
                                    editingItem={editingItem}
                                    handleGetRecursiveSearch={handleGetRecursiveSearch}
                                    handleGetRecursiveSearchFromEscalation={handleGetRecursiveSearchFromEscalation}
                                    selectedMethod={selectedMethod}
                                    barrierTypeIconMap={barrierTypeIconMap}
                                />
                            )
                        }
                    )}
                    {/* {escalationAddButton()} */}
                </>
            ) : (
                // <AddButton
                //     escalationLength={primaryBarrier ? 0 : 1}
                //     x={primaryBarrier ? x - barrierWidth / 2 + 30 : x + barrierWidth / 2 - 20}
                //     y={y + barrierHeight}
                //     onAddRequest={handleAddEscalationFactor}
                //     customText="Escalation Factor"
                //     type="ESCALATIONFACTOR"
                //     opacity={editingItem ? unfocusOpacity : 1}
                // />
                <></>
            )}

            <BarrierContainer
                transform={`translate(${x}, ${y})`}
                cursor="pointer"
                fill={theme['gray-0']}
                opacity={editingItem ? (editingItem === barrierData ? 1 : unfocusOpacity) : 1}
            >
                {bowtieAdmin && !primaryBarrier && (
                    <g className={`delete-barrier-button`}>
                        <rect width={barrierWidth + 20} height={barrierHeight / 2} fill={theme['gray-200']} />
                        <Icon
                            type="delete"
                            scale="1.2"
                            color={theme['gray-200']}
                            auxliarColor={theme['red-500']}
                            x={barrierWidth + 2}
                            clickEvent={handleDeleteClick}
                        />
                    </g>
                )}

                {!primaryBarrier && (
                    <rect x={barrierWidth / 2 - 3} y={-15} width={6} height={25} fill={theme['gray-600']} />
                )}

                <rect
                    width={barrierWidth}
                    height={barrierHeight}
                    stroke="#129A96"
                    strokeWidth={1}
                    fill={theme['gray-0']}
                />
                <rect width={barrierWidth} height={14} fill="#129A96" />
                <rect
                    x={-1}
                    y={-1}
                    width={barrierWidth + 2}
                    height={barrierHeight + 2}
                    stroke="#37A3EF"
                    strokeWidth={4}
                    fill="none"
                    opacity={editingItem === barrierData ? 1 : 0}
                />

                {/* this is the box of Icon that expand to modal */}
                <text
                    x={4}
                    y={2}
                    textAnchor="start"
                    dominantBaseline="hanging"
                    fontSize={10}
                    style={{ fontFamily: theme['font-bold'], fill: theme.static['gray-0'] }}
                >
                    {i18n('Active')}
                </text>
                {/* barrier type like procedural  */}
                <Icon
                    x={
                        barrierData?.criticality?.level !== 'HIGH' && !barrierData?.manualInteraction
                            ? barrierWidth - 14
                            : barrierData?.criticality?.level === 'HIGH' && barrierData?.manualInteraction
                            ? barrierWidth - 45
                            : barrierWidth - 30
                    }
                    y={0}
                    type={barrierData?.barrierType?.iconReference}
                    scale="0.8"
                    color={theme.static['gray-0']}
                    opacity={getZoomLevel(zoomScale) === 'level0' ? 0 : 1}
                    barrierTypeIcon={barrierTypeIconMap.get(barrierData?.barrierType?.barrierTypeIcon?.id)}
                />
                {barrierData?.criticality?.level === 'HIGH' && (
                    <Icon
                        x={barrierData?.manualInteraction ? barrierWidth - 30 : barrierWidth - 14}
                        y={0}
                        type="critical"
                        color={theme.static['gray-0']}
                        scale="0.8"
                    />
                )}
                {barrierData?.manualInteraction && (
                    <Icon x={barrierWidth - 14} type="manual" color={theme.static['gray-0']} scale="0.8" />
                )}
                <>
                    <foreignObject
                        x={4}
                        y={14 + 4}
                        width={barrierWidth - 8}
                        height={barrierHeight - 14 - 8}
                        style={{ overflow: 'hidden' }}
                    >
                        <TextContainer>{barrierData?.name}</TextContainer>
                    </foreignObject>
                    {/* this is the box of Icon that expand to modal */}
                    <rect
                        width={barrierWidth}
                        height={barrierHeight}
                        opacity={0}
                        cursor="pointer"
                        onClick={() => handleEditBarrier(barrierData, primaryBarrier ? 'BARRIER' : 'ESCALATIONBARRIER')}
                    />
                </>
            </BarrierContainer>
        </>
    )
}

export default memo(BarrierToEdit)
